import { Org, Organization } from '@/types';

export const toOrganization = (org: Org): Organization => ({
  id: org.orgid,
  name: org.name,
  imageUrl: org.branding?.logo_url || '',
  hasSso: !!(
    org.sso?.auth0_org_id ||
    org.sso?.auth0_connection_id ||
    org.sso?.provider
  ),
  archived: !!org.archived,
});
